import React, { useEffect } from "react";

import { Helmet } from "react-helmet";

import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";

import { withRouter } from "react-router";

import AccelerateSection from "../../components/blocks/AccelerateSection";
import BeginSection from "../../components/blocks/BeginSection";
import TestimonySection from "../../components/blocks/TestimonySection";
import ExpertSection from "./components/ExpertSection";
import InvestingSection from "./components/InvestingSection";
import KickStartSection from "./components/KickStartSection";
import LearningSection from "./components/LearningSection";

import BeginImage from "../../assets/images/png/individual/beginImage2.webp";
import HeaderNavigation from "../../components/layout/HeaderNavigation";
import useSelectedLocation from "../../helpers/useSelectedLocation";
import SiteFooter from "../../components/layout/SiteFooter";

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_CODE);

const options = {
  autoConfig: true,
  debug: false,
};
ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL, options);

const Individual = () => {
  const selectedLocation = useSelectedLocation();

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactPixel.pageView();
  });

  return (
    <div>
      <Helmet>
        <title>
          Building Tech Talent. Powering Global Hiring. Simplifying Global
          Payroll
        </title>
      </Helmet>
      {/* <HeaderSection /> */}
      {/* <PartnersLogoSection showNews={false} />

      */}

      <header className="pb-12 lg:pb-16 w-full relative">
        <HeaderNavigation />
      </header>

      <KickStartSection />

      <LearningSection />

      <InvestingSection />

      <AccelerateSection />

      <TestimonySection />

      <ExpertSection />

      <BeginSection
        image={
          selectedLocation?.name === "Africa" || !selectedLocation
            ? null
            : BeginImage
        }
      />
      <SiteFooter />
    </div>
  );
};

export default withRouter(Individual);
